export default "__VITE_ASSET__CfqztPSS__"